var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerTitle, } from "@iscr/components/ui/drawer";
import React, { useEffect, useMemo } from "react";
import { cls } from "./utils";
const StyledDrawer = ({ isOpen, onClose, title, description, footer, content, drawerStyle, dismissible, onAnimationEnd, zIndexClassName = "z-[2147483005]", }) => {
    const args = {
        isOpen,
        onClose,
        title,
        description,
        footer,
        content,
        drawerStyle,
        dismissible,
        onAnimationEnd,
        zIndexClassName,
    };
    const { bg, text, border, handle } = useMemo(() => {
        switch (drawerStyle) {
            // Blue header
            case "blue":
                return {
                    bg: "bg-is-blue",
                    text: "!text-white",
                    border: "!border-is-blue border-t",
                    handle: "w-[90px] bg-is2-blue-500 mt-6 h-[4px]",
                };
            // White header
            default:
                return {
                    bg: "bg-white",
                    text: "text-black",
                    handle: "w-[90px] bg-muted mt-6 h-[4px]",
                };
        }
    }, [drawerStyle]);
    // A bug in the drawer library means onAnimationEnd isn't called, so trigger it ourselves instead
    // https://github.com/emilkowalski/vaul/issues/520
    // Animation runs for 0.5s: https://github.com/emilkowalski/vaul/blob/main/src/constants.ts#L2
    useEffect(() => {
        setTimeout(() => {
            onAnimationEnd === null || onAnimationEnd === void 0 ? void 0 : onAnimationEnd(isOpen);
        }, 500);
    }, [isOpen]);
    return (_jsx(Drawer, { open: isOpen, onOpenChange: onClose, dismissible: dismissible, repositionInputs: false, children: _jsxs(DrawerContent
        // @ts-ignore children warning from forwardRef in jsx
        , { 
            // @ts-ignore children warning from forwardRef in jsx
            className: cls(["max-w-[514px] mx-auto border-none max-h-screen", bg, zIndexClassName]), styles: { handle: cls(handle, dismissible === false && "!h-[0px]") }, handle: true, children: [_jsx(DrawerHeader, { className: cls(["p-0 m-0 bg-white"]), children: _jsxs("div", { className: cls(["pt-4 pb-6 px-6 text-left", bg, text]), children: [_jsx(DrawerTitle, { className: cls(text, border, "m-0"), children: title }), description && (_jsx(DrawerDescription, { className: cls(text), children: _jsx(ConditionalComponent, Object.assign({}, args, { children: description })) }))] }) }), _jsx("div", { className: "bg-white p-6 overflow-y-auto", children: _jsx(ConditionalComponent, Object.assign({}, args, { children: content })) }), footer && (_jsx(DrawerFooter, { className: "bg-white", children: _jsx(ConditionalComponent, Object.assign({}, args, { children: footer })) })), _jsx("div", { className: "h-[44px] md:h-[62px] !bg-gray-50" })] }) }));
};
const ConditionalComponent = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    if (!children) {
        return null;
    }
    else if (typeof children === "string") {
        return _jsx("span", { children: children });
    }
    else if (React.isValidElement(children)) {
        return React.cloneElement(children, props);
    }
    else if (typeof children === "function") {
        return children(props);
    }
    else {
        return children;
    }
};
export default StyledDrawer;
